<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16HciMG/tc-custom/9781035809394.jpg?1705766242160" alt="This image is the cover for the book Bizarre Poetic World of Malcolm Tilsed"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bizarre Poetic World of Malcolm Tilsed
      </h1>
      <p class="bookDescription body article font2">
        <p>Malcolm with his familiar infectious enthusiasm would like YOU to enjoy his inspirational assured debut collection work. Each poem is unique and well-written with a charismatic and often humorous writing style. You will find the collection innovative and fresh, and the intensity of the verses will captivate you. Many were written and are set during the national COVID-19 lockdowns which offer a poignant and thoughtful voice to the silent many who suffered the isolation worse than most, owing to having underlying health conditions, which will have a contemporary appeal. Malcolm is already working on his next publication.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malcolm Tilsed
      </h2>
      
      <p class="authorDescription body article">It’s not difficult to see why Malcolm Tilsed is good at what he does. His enthusiasm for people and for detail is infectious. Malcolm is proud of the fact that he has been steeped in people management since he was a teenager. Born and raised in Poole, Dorset, he recalled how he left school at 16 on the Monday, joined Woolco’s department store in Bournemouth on the Tuesday and has carried on working in retail and shopping centre management ever since. Malcolm has worked all over the country and was courted to be centre manager at the NEW 02 arena in London. He moved to Ireland in 2018 but still offers a great wealth of knowledge to businesses from his online training company: www.greenboxmanagement.com. Malcolm is using his talents to write poetry about his real-life experience.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f6519676